module.exports = __webpack_public_path__ + "static/media/arrow-right.08629640.svg";